<template>
  <v-app id="cursoCapacitacion">
    <v-container grid-list-lg fluid>
      <v-layout row wrap>
        <v-flex xs12 class="py-0">
          <h4 class="grey--text text--darken-1">
            <v-icon small color="primary">drag_indicator</v-icon> Cursos de Capacitación
          </h4>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <!-- <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn
                    v-on="on"
                    icon
                    dark
                    small
                    color="red lighten-1"
                    @click="reportCurso()">
                    <v-icon small>insert_drive_file</v-icon>
                  </v-btn>
                </template>
                <span>PDF</span>
              </v-tooltip> -->
              <v-btn
                dark
                color="primary"
                @click="showDialog">
                Nuevo
              </v-btn>
            </v-card-title>
            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="cursos"
              :search="search"
              :rows-per-page-items="rowsPerPage"
              rows-per-page-text="Filas por página"
              no-results-text="Sin resultados"
              no-data-text="Sin registros"
              class="elevation-1"
            >
              <!-- :pagination.sync="pagination" -->
              <template v-slot:items="props">
                <td>{{ props.index + 1 }}</td>
                <td>{{ props.item.area_formacion }}</td>
                <td>{{ props.item.codigo }}</td>
                <td>{{ props.item.nombre }}</td>
                <td>
                  <!-- <span v-if="props.item.ttec_estado_carrera_tipo_id == 1"><v-chip small color="success lighten-2">habilitada</v-chip></span>
                  <span v-else><v-chip small color="warning lighten-2">cerrada</v-chip></span> -->
                  <v-switch
                    color="green lighten-1"
                    :label="(props.item.ttec_estado_carrera_tipo_id || props.item.ttec_estado_carrera_tipo_id == 'true') ? 'activo' : 'inactivo'"
                    v-model="props.item.ttec_estado_carrera_tipo_id"
                    @change="changeEsVigente(props.item.id, props.item.ttec_estado_carrera_tipo_id)"
                    hide-details
                  ></v-switch>
                </td>
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                      <v-btn
                        v-on="on"
                        icon
                        dark
                        color="primary"
                        small
                        @click="editCurso(props.item)"
                        class="mx-1"
                      >
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
            <!-- <div class="text-xs-center pt-2">
              <v-pagination total-visible="6" color="primary" v-model="pagination.page" :length="pages"></v-pagination>
            </div> -->
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="mdialog" scrollable :width="(size_width>1024?'60%':'100%')">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          <span class="headline">Agregar Curso</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-lg fluid class="py-1">
            <v-form ref="formCurso">
              <v-layout rows wrap>
                <v-flex xs6 class="py-0">
                  <v-select
                    :items="areas"
                    label="Área"
                    item-text="area_formacion"
                    item-value="id"
                    v-model="curso.ttec_area_formacion_tipo_id"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
                <v-flex xs6 sm6 class="py-0">
                  <v-text-field
                    type="text"
                    label="Código"
                    v-model.trim="curso.codigo"
                    :rules="[v => !!v || 'El campo es requerido']"
                    
                    class="txt-upper"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 class="py-0">
                  <v-text-field
                    type="text"
                    label="Denominación"
                    v-model.trim="curso.nombre"
                    :rules="[v => !!v || 'El campo es requerido']"
                    @keypress="isText($event)"
                    class="txt-upper"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loadingSend" color="success darken-1" flat @click="createCurso">
            Guardar
          </v-btn>
          <v-btn color="blue darken-1" flat @click="mdialog = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snack.state"
      top
      right
      :timeout="2500"
      :color="snack.color"
      :multi-line="snack.mode === 'multi-line'"
    >
      {{ snack.text }}
      <v-btn dark flat @click="snack.state = false">Cerrar</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import Service from "../services/general";
import axios from "axios";
export default {
  name: 'curso-capacitacion',
  data: () => ({
    search: '',
    // pagination: {
    //   totalItems: 0,
    //   rowsPerPage: 1
    // },
    rowsPerPage: [10, 20, 30, 50, 100, {'text': 'Todos', value: -1}],
    selected: [],
    loading: false,
    loadingSend: false,
    headers: [
      { text: 'Nro', align: 'left', sortable: false },
      { text: 'Área ', value: 'area' },
      { text: 'Código ', value: 'codigo' },
      { text: 'Denominación del Curso ', value: 'nombre' },
      { text: 'Estado ', value: 'estado' },
      { text: 'Acciones ', sortable: false }
    ],
    cursos: [],
    areas: [],
    curso: {
      id: '',
      ttec_area_formacion_tipo_id: '',
      codigo: '',
      nombre: ''
    },
    mdialog: false,
    size_width: 0,
    snack: {
      state: false,
      color: "success",
      mode: "",
      timeout: 2500,
      text: ""
    },
    message: ""
  }),
  mounted() {
    this.dparams = Service.getParams();
    if (this.dparams && this.dparams.roluser != Service.rol().nacional) {
      this.$router.push({name: 'principal'});
    }
    if (this.dparams != null) {
      this.getCursos();
      this.getAreas();
    }
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWidth);
      this.getWidth();
    });
  },
  methods: {
    getWidth() {
      this.size_width = document.documentElement.clientWidth;
    },
    getCursos() {
      axios.get(Service.getBase() + 'lista/cursos', Service.getHeader()).then(response => {
        this.cursos = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getAreas() {
      axios.get(Service.getServe() + 'out/areas', Service.getHeader()).then(response => {
        this.areas = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    showDialog() {
      this.curso.id = '';
      this.mdialog = true
    },
    createCurso() {
      if (this.$refs.formCurso.validate()) {
        this.loadingSend = true;
        this.curso.codigo = this.curso.codigo.toUpperCase();
        this.curso.nombre = this.curso.nombre.toUpperCase();
        if (this.curso.id == '') {
          axios
          .post(Service.getBase() + "guarda/curso", this.curso, Service.getHeader())
          .then(response => {
            this.loadingSend = false;
            if (response.data.estado == 200) {
              this.getCursos();
              this.$refs.formCurso.reset();
              this.mdialog = false;
              this.toast("success", "Registro guardado");
            } else {
              this.toast("warning", response.data.msg);
            }
          })
          .catch(error => { console.log(error);
            this.loadingSend = false;
            this.toast("error", "No se pudo guardar");
          });
        } else {
          axios
          .put(Service.getBase() + "actualiza/curso/" + this.curso.id, this.curso, Service.getHeader())
          .then(response => {
            this.loadingSend = false;
            if (response.data.estado == 200) {
              this.getCursos();
              this.$refs.formCurso.reset();
              this.mdialog = false;
              this.toast("success", "Registro actualizado");
            } else {
              this.toast("warning", response.data.msg);
            }
          })
          .catch(error => {
            this.loadingSend = false;
            this.toast("error", "No se pudo actualizar");
          });
        }
      }
    },
    editCurso(curso) {
      this.curso = curso;
      this.mdialog = true;
    },
    changeEsVigente(curso_id, es_vigente) {
      axios
        .put(Service.getBase() + 'cambia/estado/curso/' + curso_id, {es_vigente: es_vigente}, Service.getHeader())
        .then(() => {
          this.toast('success', 'Registro modificado.');
          // this.getCursos();
        })
        .catch(error => {
          console.error('Error al modificar', error);
        });
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    }
  }
};
</script>